function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\xCDbu\xF0-detail",
  transform: "translate(-1196.000000, -1086.000000)",
  fill: "#88949D"
}, React.createElement("g", {
  id: "toilet.3",
  transform: "translate(1196.000000, 1086.000000)"
}, React.createElement("path", {
  d: "M11.722,10 L2.278,10 C1.511,10 0.871,9.426 0.787,8.665 L0.009,1.665 C0.009,1.665 0.009,1.665 0.009,1.665 C-0.038,1.242 0.099,0.817 0.383,0.5 C0.667,0.183 1.074,0 1.5,0 L12.5,0 C12.926,0 13.333,0.182 13.617,0.5 C13.901,0.818 14.038,1.242 13.991,1.666 L13.213,8.666 C13.129,9.426 12.488,10 11.722,10 Z M1.003,1.556 L1.781,8.556 C1.809,8.809 2.022,9 2.278,9 L11.721,9 C11.977,9 12.191,8.809 12.218,8.556 L12.996,1.556 C13.012,1.413 12.968,1.275 12.871,1.167 C12.776,1.059 12.644,1 12.5,1 L1.5,1 C1.356,1 1.224,1.059 1.128,1.167 C1.031,1.274 0.987,1.412 1.003,1.556 Z",
  id: "Shape",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M4.5,5 C3.673,5 3,4.327 3,3.5 C3,2.673 3.673,2 4.5,2 C5.327,2 6,2.673 6,3.5 C6,4.327 5.327,5 4.5,5 Z M4.5,3 C4.225,3 4,3.224 4,3.5 C4,3.776 4.225,4 4.5,4 C4.775,4 5,3.776 5,3.5 C5,3.224 4.775,3 4.5,3 Z",
  id: "Shape",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M7.5,3 L4.5,3 C4.224,3 4,2.776 4,2.5 C4,2.224 4.224,2 4.5,2 L7.5,2 C7.776,2 8,2.224 8,2.5 C8,2.776 7.776,3 7.5,3 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M7,16 C3.521,16 0,15.141 0,13.5 C0,10.218 14,10.218 14,13.5 C14,15.141 10.479,16 7,16 Z M7,12 C3.278,12 1,12.971 1,13.5 C1,14.029 3.278,15 7,15 C10.722,15 13,14.029 13,13.5 C13,12.971 10.722,12 7,12 Z",
  id: "Shape",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M7,20 C3.01,20 0,17.206 0,13.5 C0,13.224 0.224,13 0.5,13 C0.776,13 1,13.224 1,13.5 C1,16.687 3.523,19 7,19 C10.477,19 13,16.687 13,13.5 C13,13.224 13.224,13 13.5,13 C13.776,13 14,13.224 14,13.5 C14,17.206 10.99,20 7,20 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M9.219,24 L4.781,24 C4.316,24 3.885,23.79 3.598,23.424 C3.312,23.057 3.212,22.588 3.325,22.137 L4.014,19.379 C4.08,19.111 4.357,18.946 4.62,19.015 C4.889,19.082 5.051,19.353 4.984,19.621 L4.295,22.378 C4.257,22.528 4.29,22.685 4.386,22.808 C4.482,22.93 4.626,23 4.781,23 L9.219,23 C9.374,23 9.518,22.93 9.614,22.808 C9.71,22.685 9.743,22.529 9.705,22.378 L9.016,19.621 C8.95,19.353 9.112,19.082 9.38,19.015 C9.644,18.945 9.919,19.111 9.986,19.379 L10.675,22.136 C10.787,22.588 10.688,23.057 10.402,23.424 C10.114,23.79 9.684,24 9.219,24 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M4.5,12 C4.224,12 4,11.776 4,11.5 L4,9.5 C4,9.224 4.224,9 4.5,9 C4.776,9 5,9.224 5,9.5 L5,11.5 C5,11.776 4.776,12 4.5,12 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M9.5,12 C9.224,12 9,11.776 9,11.5 L9,9.5 C9,9.224 9.224,9 9.5,9 C9.776,9 10,9.224 10,9.5 L10,11.5 C10,11.776 9.776,12 9.5,12 Z",
  id: "Path"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "14px",
    height: "24px",
    viewBox: "0 0 14 24",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/toilet.f3fd4b2f.svg";
export { SvgComponent as ReactComponent };